<template>
  <div class="focused-panel">
    <div class="d-flex lpd-toolbar">
      <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->
      <b-btn size="sm" class="dtron-toolbar-button tool1"  v-b-tooltip.hover.auto title="Create LPD" :pressed.sync="addEnabled" variant="primary">
        <icon scale=".6" name="plus"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1"  v-b-tooltip.hover.auto title="Select LPD" :pressed.sync="selectEnabled" variant="primary">
        <icon scale=".6" name="hand-pointer"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1"  :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
        <icon scale=".6" name="undo"/>
      </b-btn>
      <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
        Undo
      </b-tooltip>


      <b-btn size="sm" class="dtron-toolbar-button tool1"  v-b-tooltip.hover.auto title="Edit LPD geometry" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled"
             variant="primary">
        <icon scale=".6" name="arrows-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1"  v-b-tooltip.hover.auto title="Edit LPD attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled"
             variant="primary">
        <icon scale=".6" name="pencil-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1"  @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete LPDs" :disabled="!wellFeatureSelected"
             variant="primary">
        <icon scale=".6" name="times"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1"  :pressed.sync="ldEnabled" v-b-tooltip.hover.auto title="Load dependant layers"
             variant="primary">
        <icon scale=".6" name="link"/>
      </b-btn>

    </div>

    <b-modal no-close-on-backdrop no-close-on-esc v-model="showForm">
      <div slot="modal-header">
        <label>{{formTitle}}</label>
        <div v-if='editablePhase'>
          <div v-if="!featureLock" class='designatron-lock' v-b-tooltip.hover.auto title="Lock Feature" @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
            <span v-if='hoverLock' @click='setLockState(true)'><icon scale=".8" name="lock"/></span>
            <span v-if="!hoverLock"><icon scale=".8" name="unlock"/></span>
          </div>

          <div v-if="featureLock" class='designatron-lock' v-b-tooltip.hover.auto title="Unlock Feature" @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
            <span v-if='hoverLock' @click='setLockState(false)'><icon scale=".8" name="unlock"/></span>
            <span v-if="!hoverLock"><icon scale=".8" name="lock"/></span>
          </div>
        </div>
      </div>
      <div class="p-2">
        <div id='feature-locked-warning' v-if="!editablePhase">
          <b-alert class='user-reminder' variant="warning" show>This feature is locked. It cannot be edited in this Area of responsibility</b-alert>
        </div>
        <div id='feature-locked-warning' v-if="editablePhase && featureLock">
          <b-alert class='user-reminder' variant="warning" show>This feature is locked. Click the unlock button in the upper right to edit feature</b-alert>
        </div>
        <b-form>
          <b-form-group label="Asset Tag:" label-for="lpd-asset-tag">
            <b-form-input :disabled="featureLock" id="lpd-asset-tag" v-model="wellAttrs['asset_tag']" placeholder="Enter Asset Tag"></b-form-input>
          </b-form-group>
          <b-form-group label="LPD Type:" label-for="row-width-select" class="row-select">
            <b-form-select :options="lpdLibOptions" id="lpd-lib-select" :disabled="featureLock" v-model="wellAttrs['station_data_id']" placeholder="Please, select option"></b-form-select>
          </b-form-group>

          <b-form-group label="Comment:" label-for="lpdComment">
            <b-textarea id="lpdComment" :disabled="featureLock" v-model="wellAttrs['comment']" rows="3"></b-textarea>
          </b-form-group>
        </b-form>
      </div>
      <div slot="modal-footer" class="designatron-modal-footer">
        <b-row>
          <b-col>
            <div role="group" class="btn-group">
              <b-btn size="sm" class="float-right" variant="primary" @click="close">
                Close
              </b-btn>
              <b-btn size="sm" :disabled="featureLock" class="float-right" variant="success" @click="onOK">
                Save
              </b-btn>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>

  </div>
</template>

<script>

  import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'

  export default {
    name: 'lpd-editor',
    components: {},
    mixins: [FeatureEditorMixin],
    data () {
      return {
        geomType: 'Point',
        wellLayerName: 'v4:lpd',
        wellAttrs: {
          ident: '',
          comment: '',
          asset_tag: '',
          station_data_id: null,
          type: 'boot'
        },
        schema: 'lpd',
        hoverLock: false,
        lockable: true,
        identState: null,
        initialIdent: null,
        lpdLibOptions: [],
      }
    },
    methods: {
      _addFeature (feature) {
        feature.set('comment', 'custom')
        this.newFeatures.push(feature)
        this.propagateFeatureChange('add', [feature])
        this.save()
      },
      close(evt) {
        this.wellFeature = null
        this.showForm = false
        this.onCancel()
      },
      loadLibOptions() {
        this.$http.get('/api/layers/lpd-lib-options').then(res => {
          let fil = res.body.filter(f => f.subject)
          this.lpdLibOptions = fil.map(m => {
            return {
              text: m.subject,
              value: m.id
            }
          })
          this.lpdLibOptions = this.lpdLibOptions.concat({
            text: 'None',
            value: 0
          })
        }, res => {
          console.log('Error Thrown')
          console.log(res)
        })
      }
    },
    watch: {
      wellAttrs: {
        handler(val) {
          if (!this.initialIdent) {
            this.initialIdent = val.ident
          }
          else if (this.initialIdent !== val.ident) {
            let me = this
            this.validateIdent(val.ident)
          } else {
            this.identState = null
          }
        },
        deep: true
      },
      showForm(val) {
        if (this.lpdLibOptions.length === 0) {
          this.loadLibOptions()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/LpdEditor.vue